import React from "react"
import Typography from "../../../../../ui/atoms/Typography"
import ExpandableMenu from "../../../../../ui/molecules/ExpandableMenu"
import FilterCategoryContent from "../FilterCategoryContent"
import { FilterCategory } from "../types"

interface Props {
  expanded?: boolean
  onExpandToggle?: () => void
  filter: FilterCategory
  onFilterUpdate: (filter: FilterCategory) => void
}

const FiltersSidebarElement = ({
  filter,
  onFilterUpdate,
  expanded,
  onExpandToggle,
}: Props) => {
  return (
    <ExpandableMenu
      label={
        <Typography
          variant="body1"
          weightValue={500 as any}
          textClassName="uppercase mb-2"
        >
          {filter.name}
        </Typography>
      }
      expanded={expanded}
      onToggle={onExpandToggle}
    >
      <FilterCategoryContent
        item={filter}
        onItemUpdate={onFilterUpdate}
        maxScrollItems={10}
        minTextFilterItems={60}
        useTreeFilters
      />
    </ExpandableMenu>
  )
}

export default FiltersSidebarElement
